/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { Redirect, useLocation } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { CodeBookBbaEdit } from '../../modules/codeBook/CodeBookBbaEdit'




const EditCodeBookBbaPage: FC = () => (
    <>

        <div className='row gy-5 g-xl-8'>
            <CodeBookBbaEdit className='card-xxl-stretch' />
        </div>
        {/* end::Row */}
    </>
)

const EditCodeBookWrapperBba: FC = () => {
    const intl = useIntl()
    const { state } = useLocation()

    // Stavka za izmjenu dolazi iz tabele šifarnika; bez nje bi se otvorila prazna forma s id 0.
    if (!state) {
        return <Redirect to='/CodeBookBba' />
    }

    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.CodeBook' })}</PageTitle>
            <EditCodeBookBbaPage />
        </>
    )
}

export { EditCodeBookWrapperBba }
